import Typography from '@mui/material/Typography'
import { FormSectionProps } from '../../interfaces/form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormField from '../../components/FormField'

const Income = ({ validate }: FormSectionProps) => {
  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 4 }}>
            What’s your partner's yearly income before tax?
          </Typography>
          <Typography variant="h6" sx={{ mb: 4, fontWeight: 'normal' }}>
            Your partner's salary
          </Typography>
          <FormField
            id="income"
            name="partnerIncome"
            type="number"
            style={{ marginBottom: '80px' }}
            inputProps={{ type: 'number' }}
            InputProps={{
              startAdornment: (
                <span style={{ marginRight: 10, fontWeight: 600 }}>£</span>
              ),
              endAdornment: (
                <span style={{ marginLeft: 10, minWidth: 50 }}>/ year</span>
              ),
            }}
          />
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default Income
